import { render, staticRenderFns } from "./WorkDocumenteFaraAtasament.vue?vue&type=template&id=0314a3fd&scoped=true&"
import script from "./WorkDocumenteFaraAtasament.ts?vue&type=script&lang=ts&"
export * from "./WorkDocumenteFaraAtasament.ts?vue&type=script&lang=ts&"
import style0 from "./WorkDocumenteFaraAtasament.vue?vue&type=style&index=0&id=0314a3fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0314a3fd",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QTr,QTd}, component.options.components || {})
